module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n\n    <label>Easing: <select class="form-control" id="zoomInEasing"></select></label>\n\n    <div class="zmags-input-control small columns">\n        <div class="pull-left">\n            <label data-unit="sec">Delay: <input type="number" step="0.1" min="0" name="delay"    id="delay"></label>\n        </div>\n        <div class="pull-right">\n            <label data-unit="sec">Time: <input type="number" step="0.1" min="0" name="duration" id="duration"></label>\n        </div>\n    </div>\n\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/animations/zoomIn/ZoomInAnimationPropertiesView.tpl
// module id = 1699
// module chunks = 0